import React, { useState, useRef } from 'react';
import { Page, Label, HTML } from 'src/components/Layout';
import Helptext from 'src/components/Helptext';

export const ReturnFormHelp = () => {
  return (
    <Page title="Hjelp for returskjema" style={{alignItems:'center'}}>
      <Label as="h1" marginTop="0.5em" marginBottom="0.5em">
          Hjelp for returskjema
      </Label>

      <Helptext
        name="returnform-help"
        render={html => html && <HTML style={{width:'80%', maxWidth:'850px'}}>{html}</HTML>}></Helptext>
    </Page>
  );
};
